export const servicesData = [
  {
    id: "event-management",
    title: "Event Management & Organization",
    description: "From corporate conferences to luxury brand activations, we deliver seamless event experiences that elevate your brand and engage your audience.",
    icon: "event",
    longDescription:
      "Aura International delivers end-to-end event management and organization for corporate conferences, product launches, luxury brand activations, and bespoke experiences. We start by understanding your objectives, audience, and brand personality, then design a concept, program flow, and environment that feel uniquely yours. Our team handles venue sourcing, vendor negotiation, production, guest journeys, and on-site coordination so you can stay focused on your stakeholders instead of the checklist. After the event, we review performance, feedback, and media to capture learnings and ensure every experience contributes to your long-term brand and business goals.",
    highlights: [
      "Corporate conferences and seminars",
      "Product launches and brand activations",
      "Luxury and premium experiences",
      "Venue sourcing and management",
      "Full logistics and production",
      "On-site coordination and execution",
    ],
    benefits: [
      "One point of contact from concept to execution",
      "Premium venues and vendor partnerships",
      "Detailed planning and run-of-show management",
      "Post-event reporting and insights",
    ],
  },
  {
    id: "social-digital",
    title: "Social Media & Digital Marketing",
    description:
      "Integrated social and digital campaigns that build communities, drive traffic, and turn attention into measurable results.",
    icon: "social",
    longDescription:
      "We plan and run integrated social media and digital marketing campaigns that grow your audience and drive performance. From always-on content calendars and community management to SEO, PPC, and conversion-focused landing pages, we make sure every touchpoint works together. We define clear roles for each channel in the journey—from awareness and engagement to lead capture and remarketing—so prospects always know what to do next. Our team aligns creative, media, and analytics, continually testing and refining messages, audiences, and formats so your brand shows up consistently and your budget works harder month after month.",
    highlights: [
      "Content strategy and planning",
      "Community management and engagement",
      "Paid social campaigns and influencer partnerships",
      "SEO, PPC, and performance marketing",
      "Campaign landing pages and conversion optimization",
      "Analytics, reporting, and continuous optimization",
      "Brand voice and visual consistency across channels",
    ],
    benefits: [
      "Single, joined‑up strategy for social and digital",
      "Faster growth in reach, traffic, and engagement",
      "Better use of budget through data‑driven decisions",
      "Clear reporting and ROI visibility for every campaign",
    ],
  },
  {
    id: "construction-interior",
    title: "Construction & Interior Fit-out",
    description:
      "End‑to‑end construction coordination and interior fit‑out that deliver functional, brand‑aligned spaces.",
    icon: "construction",
    longDescription:
      "We manage construction and interior fit-out projects from early planning through handover, acting as your single point of coordination on-site. Our team supports feasibility and space planning, helps you interpret drawings and technical reports, and keeps schedules, contractors, and approvals aligned. We balance practical requirements—safety, access, services—with how you want clients and teams to feel in the finished space, making sure materials, lighting, and layout all support your brand story. From structural works to final finishes, we stay close to progress and quality so handover feels smooth and the space is ready for real-world use on day one.",
    highlights: [
      "Interior design and fit-out projects",
      "Space planning and execution",
      "Site assessments and technical coordination",
      "Contractor and vendor management",
      "Brand‑aligned materials and finishes",
      "Handover support and post‑completion tweaks",
    ],
    benefits: [
      "Single point of contact across construction and fit‑out",
      "Reduced project risk through clear coordination",
      "Spaces that support your workflow and brand",
      "On‑time, on‑budget delivery with clear communication",
    ],
  },
  {
    id: "fashion-beauty",
    title: "Fashion & Beauty",
    description:
      "Brand, retail, and campaign support for fashion and beauty businesses that want to stand out on shelf and online.",
    icon: "digital",
    longDescription:
      "We partner with fashion and beauty brands to create launch moments, campaigns, and retail experiences that feel premium and on-trend. Together we refine your positioning, tone of voice, and visual direction so every collection or range tells a clear story. Our team supports lookbook and campaign shoots, in-store merchandising and launch events, and always-on content for social and ecommerce. By connecting creative production, influencer activity, and performance media, we help you stay top of mind with the right consumers while still feeling fresh from season to season.",
    highlights: [
      "Fashion brand strategy and campaigns",
      "Beauty and lifestyle marketing",
      "Product launch and retail activations",
      "Content and creative production",
      "Influencer and partner collaborations",
      "Sector‑specific marketing support",
    ],
    benefits: [
      "Industry‑specific expertise and networks",
      "Campaigns that feel premium and on‑brand",
      "Brand‑building across physical and digital touchpoints",
      "Flexible support as your collections and ranges grow",
    ],
  },
];

export function getServiceById(id) {
  return servicesData.find((s) => s.id === id) || null;
}
